import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteIcon from "@mui/icons-material/Delete";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen,
  DeleteOrder
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    {
      Header: "",
      accessor: "checkbox",
      width: "50px",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Checkbox
          checked={selected[row.values.id] || false}
          onChange={() => handleCheckboxChange(row.values.id)}
        />
      ),
    },
    {
      Header: "",
      accessor: "expand",
      width: "100px",
      disableSortBy: true,
      Cell: ({ row }) =>
        row.values.actions ? (
          <IconButton onClick={() => row.toggleRowExpanded()}>
            <ExpandMoreIcon />
          </IconButton>
        ) : null,
    },
    {
      Header: "รูปภาพ",
      accessor: "picture",
      disableSortBy: true,
    },
    { Header: "รหัสรายการ", accessor: "order_code", showInFilter: true },
    { Header: "เลขบัตรประชาชน", accessor: "idcard", showInFilter: true },
    { Header: "ชื่อ-สกุล", accessor: "customer_name", showInFilter: true },
    { Header: "จำนวนเงิน", accessor: "total_price", showInFilter: false },
    { Header: "วันที่ทำรายการ", accessor: "created_date", showInFilter: true },
    { Header: "สถานะ", accessor: "order_status", showInFilter: false },
    { Header: "ประเภท", accessor: "product_type", showInFilter: false },
    {
      Header: "Actions",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <div>
            <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && activeRowId === row.id}
              onClose={handleMenuClose}
            >
              <MenuItem
                onClick={() => {
                  setViewProduct(row);
                  handleViewOpen();
                  handleMenuClose();
                }}
              >
                <RemoveRedEyeIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  ดูรายละเอียด
                </span>
              </MenuItem>
            </Menu>
          </div>
        );
      },
    },
  ];
  return columns;
};

export default useColumns;
